export default __webpack_public_path__ + "static/media/Frame 263.68fb97a5.svg";